import React, { Component } from "react";
import PropTypes from "prop-types";
import { GridRow, GridColumn, Carousel, Button } from "arv-reactcomponents";
import ProductView from "../../../component/ProductList/ProductView";
import { isDesktop } from "../../../utils";
import { APP_BREAKPOINTS, PDP_CAROUSEL_SIZE } from "../../../constants";

const ARROW_CLASSNAMES = {
  "brandmastertemplate2-se": "icomoon-sephora_arrow_",
  "brandmastertemplate3-ga": "icomoon-sephora_arrow_",
};
class CarouselComponent extends Component {
  static getCurrentWidth(value) {
    const newVal = parseFloat(100 / value).toFixed(2);
    return {
      width: `${newVal}%`,
    };
  }
  static renderItems(
    item,
    index,
    currentSize,
    iterationIndex,
    origin,
    className,
    title,
  ) {
    const onWinLoad = !isDesktop;
    return (
      <div
        className={`nw-pdpcarouselitem ${className}`}
        style={CarouselComponent.getCurrentWidth(currentSize)}
        key={iterationIndex}
      >
        <ProductView
          title={title}
          currentIndex={index}
          index={iterationIndex}
          link={item.url}
          mainImage={item.imagePath}
          altImage={item.altImagePath}
          imageWidth={item.imageWidth}
          imageHeight={item.imageHeight}
          imageColor={item.imageColor}
          brandText={item.brandName || item.brand}
          productTitle={item.name}
          isNew={item.isNew}
          discountRange={item.discountRange}
          mrpRange={item.mrpRange}
          sellingPriceRange={item.sellingPriceRange}
          promotions={item.promotions || []}
          isAllPromotions={false}
          styleId={item.styleId || item.id}
          moreColors={item.moreColors}
          onWinLoad={onWinLoad}
          origin={origin}
          inStock={item.inStock}
        />
      </div>
    );
  }
  static getCurrentSize(propsVal) {
    const currentWidth = window.innerWidth;
    let size = "LG";
    if (currentWidth < APP_BREAKPOINTS.XS) {
      size = "XS";
    } else if (currentWidth < APP_BREAKPOINTS.SM) {
      size = "SM";
    } else if (currentWidth < APP_BREAKPOINTS.MD) {
      size = "MD";
    }
    const valFromConfig = PDP_CAROUSEL_SIZE[size];
    let valFromProps = propsVal[size] || 10;
    valFromProps = parseInt(valFromProps, 10);
    return valFromProps || valFromConfig;
  }
  constructor(props) {
    super(props);
    this.state = {
      index: 0,
    };
    this.scroll = this.scroll.bind(this);
    this.onSwipe = this.onSwipe.bind(this);
    this.carouselSize = CarouselComponent.getCurrentSize(props.size);
    this.currentIndecesInView = [...Array(this.carouselSize).keys()];
  }

  onSwipe(direction) {
    const currentWidth = window.innerWidth;
    if (currentWidth < APP_BREAKPOINTS.SM) return null;
    this.scroll(direction.horizontal);
    return null;
  }
  get arrowClassName() {
    const { className } = this.props;
    return ARROW_CLASSNAMES[className] || "icomoon-arrow_";
  }
  scroll(type, event) {
    if (event) event.preventDefault();
    const index =
      type === "next"
        ? this.currentIndecesInView[this.carouselSize - 1]
        : this.currentIndecesInView[0];
    const newIndex = type === "next" ? index + 1 : index - 1;
    if (newIndex > -1 && newIndex < this.props.list.length) {
      if (type === "next") {
        this.currentIndecesInView.splice(0, 1);
        this.currentIndecesInView.push(newIndex);
      } else {
        this.currentIndecesInView.splice(this.carouselSize - 1, 1);
        this.currentIndecesInView.unshift(newIndex);
      }
      this.setState({ index: newIndex });
    }
  }

  render() {
    const { list, origin, className, title } = this.props;
    const { index } = this.state;
    return (
      <GridRow className="nw-pdpcarouselrow">
        <GridColumn
          className={`nw-productcarousel-btncol nw-productcarousel-btncol-left ${className}`}
        >
          {list.length > this.carouselSize ? (
            <Button
              disabled={index === 0}
              className={`nwc-btn-primary-txt nw-pdpcarouselbutton ${className}`}
              onClick={e => this.scroll("prev", e)}
            >
              <i
                className={`${
                  this.arrowClassName
                }left nw-pdpcarouselicon ${className}`}
              />
            </Button>
          ) : (
            <div />
          )}
        </GridColumn>
        <GridColumn className={`nw-pdpcarouselcolumn ${className}`}>
          <Carousel
            onSwipe={this.onSwipe}
            className={`nw-pdpcarouselenclose  ${className} ${
              list.length <= this.carouselSize ? "is-noscroller" : ""
            }`}
            index={index}
            items={list}
            renderItems={(item, iterationIndex) =>
              CarouselComponent.renderItems(
                item,
                index,
                this.carouselSize,
                iterationIndex,
                origin,
                className,
                title,
              )
            }
          />
        </GridColumn>
        <GridColumn
          className={`nw-productcarousel-btncol nw-productcarousel-btncol-right ${className}`}
        >
          {list.length > this.carouselSize ? (
            <Button
              disabled={index === list.length - 1}
              className={`nwc-btn-primary-txt nw-pdpcarouselbutton ${className}`}
              onClick={e => this.scroll("next", e)}
            >
              <i
                className={`${
                  this.arrowClassName
                }right nw-pdpcarouselicon ${className}`}
              />
            </Button>
          ) : (
            <div />
          )}
        </GridColumn>
      </GridRow>
    );
  }
}

CarouselComponent.propTypes = {
  title: PropTypes.string.isRequired,
  list: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  size: PropTypes.shape({}).isRequired,
  origin: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

export default CarouselComponent;



// WEBPACK FOOTER //
// ./src/component/ProductCarousel/CarouselComponent/index.js